import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import CustomSlider from './CustomSlider';
import { setTextOnly } from '../Utils';

class PhotoEditor extends Component {
    render() {
        const { messages } = this.props.intl;
        return (
            <div className="react-avatar-right-column-top" style={{ display: setTextOnly()=='1'?'none':'block'}}>
                <div className="react-avatar-right-column-top-header">
                    <p className="react-avatar-right-column-top-header-text">
                        {messages.image}
                    </p>
                </div>
                <CustomSlider
                    min={0.1}
                    max={8}
                    defaultValue={1}
                    step={0.1}
                    onChange={this.props.onZoomChange}
                    className="react-avatar-slider-zoom"
                    text={messages.zoom}
                />

                <CustomSlider
                    min={0}
                    max={360}
                    onChange={this.props.onRotationChange}
                    className="react-avatar-slider-rotation"
                    text={messages.rotation}
                />
            </div>
        );
    }
}

export default injectIntl(PhotoEditor);



// WEBPACK FOOTER //
// ./src/Components/PhotoEditor.js